export default "__VITE_ASSET__d6e38010__"